import { ACTION_TYPES } from '../../utils/Constants';

const AdminModuleReducer = (
    state = {
        physicianHandoutList: [],
    },
    action = {}
) => {
    switch (action.type) {
        case ACTION_TYPES.PHYSICIAN.GET_PHYSICIAN_HANDOUT:
            state = {
                ...state,
                physicianHandoutList: action.payload,
            };
            break;
        default:
            break;
    }
    return state;
};

export default AdminModuleReducer;
